import { formatPercentage, numberShorthand } from '@benzinga/utils';
import type { ShortInterestSummary } from '../../utils/quote/summaries';
import { useTranslation } from 'react-i18next';
import { KPIBox } from './KPIBox';

export const ShortInterestSummaryBox: React.FC<{ shortInterestSummary: ShortInterestSummary }> = ({
  shortInterestSummary,
}) => {
  const { t } = useTranslation('quote');

  const shortInterest = shortInterestSummary?.last ?? null;
  if (!shortInterest) return null;

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      <KPIBox
        label={t('Quote.ShortInterest.short-interest')}
        value={shortInterest.totalShortInterest ? numberShorthand(Number(shortInterest.totalShortInterest), 2) : '–'}
      />
      <KPIBox
        label={`${t('Quote.ShortInterest.short-interest')} %`}
        value={shortInterest.shortPercentOfFloat ? `${formatPercentage(shortInterest.shortPercentOfFloat)}%` : '–'}
      />
      <KPIBox label={t('Quote.ShortInterest.days-to-cover')} value={`${shortInterest.daysToCover ?? '-'}`} />
    </div>
  );
};

export default ShortInterestSummaryBox;
